import apiClient from "./api";
import { SET_USERS, SET_TOKENS, LOGOUT, UPDATE_BALANCE } from "./constants";
import { loadPagePermissions } from "./permissions";

export const loadUser = () => async (dispatch) => {
  try {
    const res = await apiClient.get("/users/get");

    dispatch({
      type: SET_USERS,
      payload: res.data,
    });
    await dispatch(loadPagePermissions());
  } catch (err) {
    console.log(err);
  }
};

export const register = (token) => async (dispatch) => {
  dispatch({
    type: SET_TOKENS,
    payload: token,
  });

  dispatch(loadUser());
};

export const login = (token) => async (dispatch) => {
  dispatch({
    type: SET_TOKENS,
    payload: token,
  });

  dispatch(loadUser());
};

export const logout = () => ({ type: LOGOUT });

// Balance changes are intentionally separate from user-profile changes. This
// keeps the user object stable and prevents user-dependent page effects from
// refetching data after a billed action.
export const updateBalance = (balance) => ({
  type: UPDATE_BALANCE,
  payload: balance,
});
